import React from "react";
import { SettingContentType } from "../../recoil/settings";

interface SettingProps {
  mainKey: string;
  subKey: string;
  item: SettingContentType;
  editSetting: (key: string, subKey: string, value: string) => void;
}

const RadioSetting = ({ mainKey, subKey, item, editSetting }: SettingProps) => {
  return (
    <div className="itemWrap">
      <h2 className="title">{item.name}</h2>
      <div className="content">
        {item.content_list.map((content, index) => (
          <button
            key={index}
            className={`${item.value === content && "active"}`}
            onClick={() => editSetting(mainKey, subKey, content)}
          >
            <h2>{content}</h2>
          </button>
        ))}
      </div>
    </div>
  );
};
export default RadioSetting;
